import { map } from 'lodash'
import React from 'react'

import ListGroup, {
  ListGroupItem,
} from '../../../1stlog-ui/src/components/ListGroup'
import { Item } from './Item'

const Hazmat = (props) => {
  const { items } = props

  return (
    <>
      <ListGroup>
        {map(items, (item, index) => {
          return (
            <ListGroupItem key={index}>
              <Item item={item} />
            </ListGroupItem>
          )
        })}
      </ListGroup>
    </>
  )
}

export default Hazmat
